import { useState } from "react";

import { Badge, IconButton, Popover } from "@mui/material";

import { SearchSettingsCheckbox } from "components/UI/SearchSettings/SearchSettingsCheckbox";

import styles from "./CheckboxMultipleOptionsFilter.module.css";

export const CheckboxMultipleOptionsFilter = ({ checkedCount, openPopoverIcon, checkboxesData, popoverProps }) => {
	const [anchorEl, setAnchorEl] = useState(null);

	return (
		<>
			<Badge
				color="primary"
				overlap="circular"
				badgeContent={checkedCount}
				sx={{
					"& .MuiBadge-standard": {
						padding: "0px 3px",
						minWidth: "10px",
						height: "10px",
						top: "35%",
						right: "25%",
						fontWeight: 400,
						fontSize: "6px",
					},
				}}
			>
				<IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)} sx={{ padding: "4px" }}>
					{openPopoverIcon}
				</IconButton>
			</Badge>
			<Popover
				open={Boolean(anchorEl)}
				anchorEl={anchorEl}
				onClose={() => setAnchorEl(null)}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
				{...popoverProps}
			>
				<div className={styles.container}>
					{checkboxesData.map(({ label, value, setValue }) => {
						return <SearchSettingsCheckbox label={label} value={value} setValue={setValue} />;
					})}
				</div>
			</Popover>
		</>
	);
};
